import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import showSnackbar from 'components/shared/Snackbar';
import showError from 'components/shared/showError';
import { queryKeys, requests } from 'RestAPIs/rapini';

import type { ProtocolRuleResponse } from 'generated/index';

/**
 * Deletes a rule once the user has confirmed it, then refetches the list (the detail reads its rules
 * from it). The generated delete hook binds the rule id when it is called, but the trash can targets a
 * different rule per row, so the request goes through `useMutation` with the rule as its variable.
 */
export const useDeleteProtocolRule = (protocolId: string) => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const { mutate: deleteRule } = useMutation(
    (rule: ProtocolRuleResponse) =>
      requests.deleteProtocolRule(protocolId, rule.id),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKeys.getProtocols());
        showSnackbar({
          severity: 'success',
          message: t('adminPortal.protocols.detail.ruleDeleted')
        });
      },
      onError: showError
    }
  );

  return { deleteRule };
};
